const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://jobmd.top/api";

export const apiUrl = (path = "") => {
  const normalizedPath = path.startsWith("/") ? path.slice(1) : path;
  return `${API_BASE_URL}/${normalizedPath}`;
};

export const fileUrl = (path = "") => {
  const normalizedBase = API_BASE_URL.replace(/\/api\/?$/, "");
  const normalizedPath = path.startsWith("/") ? path.slice(1) : path;
  return `${normalizedBase}/${normalizedPath}`;
};

export { API_BASE_URL };
